import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaMenuComponent, CaMenuDirective, CaMenuItemComponent } from '@global-front-components/ui/menu';
import { CaIcon } from '@global-front-components/ui/form-field';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthStoreService } from '../../services/store/auth-store.service';
import { Router } from '@angular/router';
import { UsuarioConectado } from '../../model/auth.model';
import { CaModalOverlayService, ModalConfig } from '@global-front-components/ui/modal-overlay';
import { Subject, takeUntil } from 'rxjs';
import { ModalSuplantacionComponent } from '../modal-suplantacion/modal-suplantacion.component';
import { AuthService } from '../../services/api/auth.service';

@Component({
	selector: 'app-usuario-conectado',
	standalone: true,
	imports: [
		CommonModule,
		CaMenuComponent,
		CaMenuItemComponent,
		CaMenuDirective,
		CaIcon,
		TranslateModule],
	templateUrl: './usuario-conectado.component.html',
	styleUrls: ['./usuario-conectado.component.scss']
})
export class UsuarioConectadoComponent implements OnInit, OnDestroy {
	usuario: UsuarioConectado;
	private _destroy$: Subject<void> = new Subject<void>();
	info = '';
	modalConfig: ModalConfig;

	constructor(
		private _modalService: CaModalOverlayService,
		private authStoreService: AuthStoreService,
		private authService: AuthService,
		private translateService: TranslateService,
		private router: Router
	) { }

	ngOnInit(): void {
		this.authStoreService.getUsuarioConectado()
			.subscribe(user => this.usuario = user);
		this.translateService.get('MENU.PUBLICO.MENU_USUARIO.MODAL_SUPLANTAR.TITULO')
			.subscribe(title => {
				this.modalConfig = {
					title,
					windowDrag: true,
					backdropClick: true,
					size: 'm',
					isBodyScrollable: true,
					closable: true,
					minimizable: false,
					maximizable: false
				};
		});
	}

	abrirModalSuplantar() {
		const modalRef = this._modalService.open(ModalSuplantacionComponent, this.modalConfig);
		modalRef
		  .afterClosed()
		  .pipe(takeUntil(this._destroy$))
		  .subscribe(() => {
			this.authStoreService.updateUsuarioConectado();
		  });
	}

	finalizarSuplantacion(){
		this.authService.finSuplantar().subscribe({
			next: () => {
				this.authStoreService.clearSuplantado();
				this.router.navigate(['/']);
			},
			error: (err) => console.error('Error finalizar suplantacion usuario:', err),
		});
	}

	logout(): void {
		this.authStoreService.logout();
	}

	ngOnDestroy() {
		this._destroy$.next();
		this._destroy$.unsubscribe();
	}
}
